<template>
    <div class="avatar">
        <span class="img" v-if="url" v-bind:style="{ backgroundImage: 'url(' + url + ')' }"></span>
        <span v-else class="letters" :style="'background-color:' + stringToHslColor(50, 50)">{{ nameTag() }}</span>
        <div v-if="!condensed" class="meta">
            <div class="name" v-if="!hideName && (firstName || lastName)">
                {{ firstName }}
                {{ lastName }}
            </div>
            <div v-if="!hideEmail" class="email">
                {{ email }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserAvatar',
    props: {
        url: {
            type: String,
        },
        firstName: {
            type: String,
        },
        lastName: {
            type: String,
        },
        email: {
            type: String,
        },
        hideName: {
            type: Boolean,
        },
        hideEmail: {
            type: Boolean,
        },
        condensed: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        stringToHslColor(s, l) {
            //s = saturation
            //l = lightness
            var str = this.firstName + this.lastName;
            if (str) {
                var hash = 0;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }

                var h = hash % 360;
                return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
            }
            return '';
        },
        nameTag(r) {
            let tag = '';
            if (this.firstName) {
                tag = this.firstName.charAt(0);
            }
            if (this.lastName) {
                tag += this.lastName.charAt(0);
            }
            return tag;
        },
    },
};
</script>

<style lang="scss">
/* Avatars
========================================================== */
.autocomplete,
.dropdown-users {
    .avatar {
        span {
            width: 25px;
            height: 25px;
            flex: 0 0 25px;

            &.letters {
                font-size: 1.4rem;
            }
        }
        .meta {
            margin-left: 5px;
        }
    }
}

.avatar {
    display: flex;
    align-items: center;
    margin-right: 10px;

    span {
        display: flex;
        height: 40px;
        width: 40px;
        flex: 0 0 40px;
        border-radius: 100%;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        color: var(--primary);
    }

    span.letters {
        font-weight: bold;
        font-size: 1.2rem;
        color: #fff;
        text-transform: uppercase;
    }
    .meta {
        margin-left: 10px;
    }

    .name {
        font-weight: 500;
    }
    .email {
        font-size: 1.2rem;
    }

    //different size
    &.xl {
        span {
            height: 50px;
            width: 50px;
            flex: 0 0 50px;
        }

        span.letters {
            font-size: 1.8rem;
            line-height: 50px;
        }
    }

    &.xxl {
        span {
            height: 80px;
            width: 80px;
            flex: 0 0 80px;
        }

        span.letters {
            font-size: 2.2rem;
            line-height: 80px;
        }
    }

    &.sm {
        span {
            height: 25px;
            width: 25px;
            flex: 0 0 25px;
        }

        span.letters {
            font-size: 1rem;
            line-height: 25px;
        }
    }

    &.xs {
        span {
            height: 15px;
            width: 15px;
            flex: 0 0 15px;
        }

        span.letters {
            font-size: 0.7rem;
            line-height: 10px;
        }
    }
}
</style>
